<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-project-leads-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Project Leads
            </h4>
          </div>

          <div class="modal-body">
            <SelectFormGroup
                v-model="data.project_id"
                name="project"
                label="Project"
                :options="projectOptions"
                :error="(errors.project_id || [])[0]"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {SelectFormGroup},

  mixins: [Errors],

  props: {
    selected: {
      type: Array
    },

    projects: {
      type: Array
    }
  },

  data() {
    return {
      data: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  computed: {
    projectOptions() {
      return this.projects.map(project => {
        return {
          value: project.id,
          label: project.attributes.portal_name + ' - ' + project.attributes.project_category_name + ' - ' + project.attributes.name
        }
      })
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if (!this.data.project_id) {
        this.errors = {project_id: ["The project field is required"]}

        return
      }

      this.errors = {}

      Promise
          .all(this.selected.map(company => http.post('/api/v2/project-leads', {...this.data, 'company_id': company.id}).catch(() => {
          })))
          .then(() => {
            notify.success('The project leads were created')

            this.$emit('updated')

            $(this.$el).modal('hide')
          })
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
